export const experienceData = [
  {
    id: 1,
    company: "IEEE-CS VIT Student Chapter",
    jobtitle: "Research and Development Head",
    startYear: "2023",
    endYear: "Present",
  },
  {
    id: 2,
    company: "Training and Placement Cell, VIT",
    jobtitle: "Student Coordinator",
    startYear: "2022",
    endYear: "Present",
  },
  {
    id: 3,
    company: "Pixelate, VIT",
    jobtitle: "Co-Secretary",
    startYear: "2022",
    endYear: "2023",
  },
];
